import {actions} from './actions'
import {getters} from './getters'
import {mutations} from './mutations'

const state = {
    accessToken: null,
    impersonateToken: null,
    enableRefresh: true,
    refreshToken: null,
    currentUser: {}
};

export default {
    state,
    actions,
    getters,
    mutations
}
